module.exports = __webpack_public_path__ + "img/icon-water-heater.ce4b20e7.svg";